import React from 'react';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { useAuth } from '@leagueplatform/auth-utils';
import { useNavigate } from 'react-router-dom';
import { ErrorState } from 'components/error-state/error-state.component';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { ERROR_TYPES } from 'hooks/use-error-content/use-error-content.hook';
import ErrorIcon from 'assets/error-icon.svg';
import { AuthSessionContent } from './auth-session-content.component';

export const AuthSessionContainer = () => {
  const { isAuthenticated, error: authError } = useAuth({
    redirectToLogInWhenSignedOut: true,
  });

  const navigate = useNavigate();

  if (authError) {
    return (
      <ErrorState
        isFullPage
        error={authError}
        errorType={ERROR_TYPES.AUTH_ERROR}
        buttonAction={() => {
          navigate(APP_MANAGED_ROUTES.LANDING_PAGE, { replace: true });
        }}
        imageSrc={ErrorIcon}
      />
    );
  }

  if (!isAuthenticated) return <LoadingIndicator />;

  return <AuthSessionContent />;
};
